import { IMAGES_PER_PAGE } from '../../constants/studio';

export function getFilters({ order, page, query }) {
  const filters = { limit: IMAGES_PER_PAGE, offset: page * IMAGES_PER_PAGE };

  if (order?.by) {
    filters.order_by = order.by;
    filters.order_type = order.type;
  }

  if (query) {
    filters.title_or_sku = query;
  }

  return filters;
}
